import React from 'react';
import Select from '../../../components/ui/Select';

import { useLanguage } from '../../../contexts/LanguageContext';

const LocationSelection = ({ selectedCountry, selectedLocation, onCountryChange, onLocationChange }) => {
  const { t } = useLanguage();

  const countryOptions = [
    { value: 'canada', label: 'Canada' },
    { value: 'usa', label: 'United States' },
    { value: 'remote', label: 'Remote (Any Location)' }
  ];

  const canadaProvinces = [
    { value: 'ab', label: 'Alberta' },
    { value: 'bc', label: 'British Columbia' },
    { value: 'mb', label: 'Manitoba' },
    { value: 'nb', label: 'New Brunswick' },
    { value: 'nl', label: 'Newfoundland and Labrador' },
    { value: 'ns', label: 'Nova Scotia' },
    { value: 'on', label: 'Ontario' },
    { value: 'pe', label: 'Prince Edward Island' },
    { value: 'qc', label: 'Quebec' },
    { value: 'sk', label: 'Saskatchewan' },
    { value: 'nt', label: 'Northwest Territories' },
    { value: 'yt', label: 'Yukon' },
    { value: 'nu', label: 'Nunavut' }
  ];

  const usaStates = [
    { value: 'al', label: 'Alabama' },
    { value: 'ak', label: 'Alaska' },
    { value: 'az', label: 'Arizona' },
    { value: 'ar', label: 'Arkansas' },
    { value: 'ca', label: 'California' },
    { value: 'co', label: 'Colorado' },
    { value: 'ct', label: 'Connecticut' },
    { value: 'de', label: 'Delaware' },
    { value: 'fl', label: 'Florida' },
    { value: 'ga', label: 'Georgia' },
    { value: 'hi', label: 'Hawaii' },
    { value: 'id', label: 'Idaho' },
    { value: 'il', label: 'Illinois' },
    { value: 'in', label: 'Indiana' },
    { value: 'ia', label: 'Iowa' },
    { value: 'ks', label: 'Kansas' },
    { value: 'ky', label: 'Kentucky' },
    { value: 'la', label: 'Louisiana' },
    { value: 'me', label: 'Maine' },
    { value: 'md', label: 'Maryland' },
    { value: 'ma', label: 'Massachusetts' },
    { value: 'mi', label: 'Michigan' },
    { value: 'mn', label: 'Minnesota' },
    { value: 'ms', label: 'Mississippi' },
    { value: 'mo', label: 'Missouri' },
    { value: 'mt', label: 'Montana' },
    { value: 'ne', label: 'Nebraska' },
    { value: 'nv', label: 'Nevada' },
    { value: 'nh', label: 'New Hampshire' },
    { value: 'nj', label: 'New Jersey' },
    { value: 'nm', label: 'New Mexico' },
    { value: 'ny', label: 'New York' },
    { value: 'nc', label: 'North Carolina' },
    { value: 'nd', label: 'North Dakota' },
    { value: 'oh', label: 'Ohio' },
    { value: 'ok', label: 'Oklahoma' },
    { value: 'or', label: 'Oregon' },
    { value: 'pa', label: 'Pennsylvania' },
    { value: 'ri', label: 'Rhode Island' },
    { value: 'sc', label: 'South Carolina' },
    { value: 'sd', label: 'South Dakota' },
    { value: 'tn', label: 'Tennessee' },
    { value: 'tx', label: 'Texas' },
    { value: 'ut', label: 'Utah' },
    { value: 'vt', label: 'Vermont' },
    { value: 'va', label: 'Virginia' },
    { value: 'wa', label: 'Washington' },
    { value: 'wv', label: 'West Virginia' },
    { value: 'wi', label: 'Wisconsin' },
    { value: 'wy', label: 'Wyoming' }
  ];

  const getLocationOptions = () => {
    if (selectedCountry === 'canada') return canadaProvinces;
    if (selectedCountry === 'usa') return usaStates;
    return [];
  };

  return (
    <div className="w-full">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
        {t('onboarding.locationTitle')}
      </h2>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-6 md:mb-8">
        {t('onboarding.locationSubtitle')}
      </p>

      <div className="space-y-6">
        <Select
          label={t('onboarding.country')}
          description="Select your primary work location"
          options={countryOptions}
          value={selectedCountry}
          onChange={onCountryChange}
          required
        />

        {selectedCountry && selectedCountry !== 'remote' && (
          <Select
            label={selectedCountry === 'canada' ? t('onboarding.province') : t('onboarding.state')}
            description={selectedCountry === 'canada' ? t('onboarding.selectProvince') : t('onboarding.selectState')}
            options={getLocationOptions()}
            value={selectedLocation}
            onChange={onLocationChange}
            searchable
            required
          />
        )}
      </div>
    </div>
  );
};

export default LocationSelection;